import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Col, Row } from 'react-flexbox-grid';
import { Subheader, Checkbox } from 'material-ui';

import { get, map } from 'lodash';
import { fetch, fetchHolidayOverview, requestHolidayInfo } from 'actions/EmployeeHoliday';
import HolidayEntry from 'components/HolidayEntry';
import PanelMessage from 'components/panels/PanelMessage';
import Loading from 'components/Loading';
import { getSettingByKey, setSettingByKey } from 'utils/localSettings';
import styles from 'styles/EmployeeHoliday';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { fetchHolidayByYear } from '../actions/EmployeeHoliday';

const HOLIDAY_LOCAL_KEY = 'showHolidayByHour';

const EmployeeHoliday = ({
  loaded,
  error,
  hasError,
  holidays,
  holidayOverview,
  overviewLoaded,
  fetchInfo,
  fetchByYear,
  holidayCheckInfo,
  fetchingByYear,
  earnedHolidayInfo,

}) => {
  const [showByHour, setShowByHour] = useState(getSettingByKey(HOLIDAY_LOCAL_KEY) || false);
  const [yearOptions, setYearOptions] = useState([]);
  const [selectedYear, setSelectedYear] = useState(2025);
  const holiday = get(holidays, '0', null);

  useEffect(() => {
    const holidayYear = get(holidayCheckInfo, 'payYear');
    if (holidayYear) {
      setSelectedYear(holidayYear);
      const years = [
        holidayYear,
        holidayYear - 1,
      ];
      setYearOptions(years);
    }
  }, [holidayCheckInfo]);

  useEffect(() => {
    fetchInfo();
  }, []);

  const toggleShowByHour = () => {
    setSettingByKey(HOLIDAY_LOCAL_KEY, !showByHour);
    setShowByHour(!showByHour);
  };

  const onFetchByYear = (year) => {
    setSelectedYear(year);
    fetchByYear(year);
  };

  if (!loaded || !overviewLoaded) {
    return <Loading />;
  }

  if (hasError) {
    return (
      <Col xs={12} sm={12} md={6} mdOffset={3}>
        <PanelMessage
          type="error"
          iconName="error"
          message={error.Message || <FormattedMessage id="holiday.error" />}
        />
      </Col>
    );
  }

  if ((!holidays || !holidays.length) && !earnedHolidayInfo) {
    return (
      <Col xs={12} sm={12} md={6} mdOffset={3}>
        <PanelMessage
          type="info"
          iconName="info"
          message={<FormattedMessage id="tile.holiday.empty" />}
        />
      </Col>
    );
  }

  return (
    <Col xs style={{ paddingTop: 16, paddingBottom: 16 }}>
      <div style={styles.content}>
        <Subheader style={styles.subheader}>
          <FormattedMessage id="holiday.title" />
        </Subheader>
        <div style={styles.actionHeader}>
          <div style={styles.checkbox}>
            <Checkbox
              style={styles.toggle}
              onCheck={toggleShowByHour}
              checked={showByHour}
              label={<FormattedMessage id="holiday.showByHour" />}
              labelPosition="right"
            />
          </div>
          <div style={{ color: 'black' }}>
            <FormattedMessage id="holiday.label.year" />
          </div>
          <div>
            <SelectField
              style={styles.select}
              value={selectedYear}
              onChange={(event, index, value) => onFetchByYear(value)}
            >
              {map(yearOptions, year => (
                <MenuItem
                  key={year}
                  value={year}
                  primaryText={year}
                />
              ))}
            </SelectField>
          </div>
        </div>
        <Col style={styles.wrap} xs>
          <HolidayEntry
            showByHour={showByHour}
            earnedHolidayInfo={earnedHolidayInfo}
            Overview={holidayOverview}
            fetchingByYear={fetchingByYear}
            selectedYear={selectedYear}
            {...holiday}
          />
        </Col>
      </div>
    </Col>
  );
};

EmployeeHoliday.propTypes = {
  loaded: PropTypes.bool.isRequired,
  holidays: PropTypes.array.isRequired,
  holidayOverview: PropTypes.object,
  overviewLoaded: PropTypes.bool.isRequired,
  error: PropTypes.object,
  hasError: PropTypes.bool.isRequired,
  fetchInfo: PropTypes.func.isRequired,
  fetchByYear: PropTypes.func.isRequired,
  payYear: PropTypes.number.isRequired,
  holidayCheckInfo: PropTypes.object.isRequired,
  earnedHolidayInfo: PropTypes.object.isRequired,
  fetchingByYear: PropTypes.bool.isRequired,
};

EmployeeHoliday.defaultProps = {
  error: null,
  holidayOverview: {},
};

const mapStateToProps = ({ EmployeeHolidayReducer }) => ({ ...EmployeeHolidayReducer });

export default connect(
  mapStateToProps,
  dispatch => ({
    fetchByYear: (year) => {
      dispatch(fetchHolidayByYear(year));
    },
    fetchInfo: () => {
      dispatch(fetch());
      dispatch(fetchHolidayOverview());
      dispatch(requestHolidayInfo());
    },
  }),
)(EmployeeHoliday);



// WEBPACK FOOTER //
// ./src/containers/EmployeeHoliday.js